import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
const AddressUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // form fields
    address, onAddressChange, addressError, setAddressError,
    city, onCityChange, cityError, setCityError,
    state, onStateChange, stateList, stateError, setStateError,
    postalCode, onPostalCodeChange, postalCodeError, setPostalCodeError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Update address'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='address' label='Address'
            value={address} onChange={onAddressChange}
            error={addressError} setError={setAddressError}
        />
        <InputTextSF type='text' name='city' label='City'
            value={city} onChange={onCityChange}
            error={cityError} setError={setCityError}
        />
        <InputSelectSF type='text' name='state' label='State'
            required={true}
            value={state} onChange={onStateChange} optionList={stateList}
            error={stateError} setError={setStateError}
        />
        <InputTextSF type='text' name='postalCode' label='Postal code'
            value={postalCode} onChange={onPostalCodeChange}
            error={postalCodeError} setError={setPostalCodeError}
        />
    </ModalFormUI>

export default AddressUpdateModalUI
